<app-attention-modal
  type="error"
  [title]="modalTitle"
  [subtitle]="modalSubTitle"
  [messageTemplate]="errorBlocks && errorBlocks.length ? messageList : message"
  [buttonsTemplate]="buttons"
></app-attention-modal>

<ng-template #message>{{ messageText }}</ng-template>

<ng-template #messageList>
  <div class="message-list">
    @for (message of errorBlocks; track message) {
      <div class="message-block">
        <div class="title">{{ message.title }}</div>
        @for (field of message.fields; track field) {
          <div class="field">Missing {{ field }}</div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #buttons>
  <button rktButton type="button" class="error-btn" (click)="activeModal.close(true)" title="Okay">Okay</button>
</ng-template>
